import React from "react";
import Image from "next/image";
import styles from "../../styles/shap_of_you.module.scss";
import WelcomeScreenImg from "../../assets/images/WelcomeScreen.png";
import SOYLockUp from "../../assets/images/SOYLockUp.png";
import { MobileNavigationProps } from "./types";

const WelcomeScreen: React.FC<MobileNavigationProps> = ({ navigateToStep }) => {
  return (
    <div className="d-md-none w-100">
      <div className={styles.mobile_view_shap_welcome}>
        <div className={styles.bgImage}>
          <Image src={WelcomeScreenImg} alt="Welcome Screen" />
        </div>
        <div className={styles.shapeOfYou}>
          <div className={styles.content}>
            <div className={styles.title}>
              <Image src={SOYLockUp} alt="Shape of You Logo" />
            </div>
            <button
              className={styles.ctaBtn}
              onClick={() => navigateToStep("uploadOrScan")}
            >
              Start Experience →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;
